module.exports = __webpack_public_path__ + "img/dettaglio bagno 2.47322949.jpeg";